import React from "react";
import Popover from "@mui/material/Popover";
import MyProfileIcon from "../../../Assets/Account/MyProfile.svg";
import ManageUsersIcon from "../../../Assets/Account/ManageUsers.svg";
import SettingIcon from "../../../Assets/Account/Settings.svg";
import LogOutIcon from "../../../Assets/Account/logout.svg";
import { formatUserName, getInitials } from "../../../lib/utils/utils";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../../Features/settingsSlice";
import { useNavigate } from "react-router-dom";
import useAuthentication from "../../../Hooks/useAuthentication";

export default function AccountsOptions({
    open,
    onClose,
    anchorEl,
    email,
    name,
    file,
}) {
    const { logout } = useAuthentication();

    const handleLogout = () => {
        // localStorage.clear();
        // sessionStorage.clear();
        // window.location.href = "/signin";

        logout();
    };

    const navigate = useNavigate();
    const dispatch = useDispatch();

    function handleMyProfileClick() {
        navigate('/settings');
        dispatch(setActiveTab('myProfile'));
    }

    function handleManageUsersClick() {
        navigate('/settings');
        dispatch(setActiveTab('manageMembers'));
    }

    function handleSettingsClick() {
        navigate('/settings');
        dispatch(setActiveTab('myProfile'));
    }

    return (
        <Popover
            onClose={onClose}
            anchorEl={anchorEl}
            open={open}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
        >
            <div className="px-4 py-3 flex flex-col gap-3">
                <div className="flex items-center gap-[7px] pb-2 border-b border-solid border-greyea">
                    <div className="font-mulish">
                        {file ? (
                            <img
                                src={file}
                                alt=""
                                className="w-[46px] h-[46px] rounded-full"
                            />
                        ) : (
                            <div className="w-[46px] h-[46px] bg-greyea text-[#666666] rounded-full flex items-center justify-center font-semibold">
                                {getInitials(name)}
                            </div>
                        )}
                    </div>
                    <div className="">
                        <div className="text-[16px] leading-[16px] font-semibold pb-1">
                            {formatUserName(name)}
                        </div>
                        <div className="text-[12px] leading[14px] ">
                            {email}
                        </div>
                    </div>
                </div>
                <div
                    className="flex gap-2 items-center cursor-pointer"
                    onClick={handleMyProfileClick} 
                >
                    <img
                        src={MyProfileIcon}
                        alt=""
                        className="w-[19px] h-[19px]"
                    />
                    <div className="text-[16px] leading-8 font-medium">
                        My Profile
                    </div>
                </div>
                <div
                    className="flex gap-2 items-center cursor-pointer"
                    onClick={handleManageUsersClick} 
                >
                    <img
                        src={ManageUsersIcon}
                        alt=""
                        className="w-[19px] h-[19px]"
                    />
                    <div className="text-[16px] leading-8 font-medium">
                        Manage Users
                    </div>
                </div>
                <div
                    className="flex gap-2 items-center border-b border-solid border-greyea cursor-pointer"
                    onClick={handleSettingsClick} 
                >
                    <img
                        src={SettingIcon}
                        alt=""
                        className="w-[19px] h-[19px]"
                    />
                    <div className="text-[16px] leading-8 font-medium">
                        Settings
                    </div>
                </div>
                <div
                    className="flex gap-2 items-center cursor-pointer"
                    onClick={handleLogout}
                >
                    <img
                        src={LogOutIcon}
                        alt=""
                        className="w-[19px] h-[19px]"
                    />
                    <div className="text-[16px] leading-8 font-medium text-red-500">
                        Logout
                    </div>
                </div>
            </div>
        </Popover>
    );
}
